<template>
  <div class="mdb-vector-map__toolbar">
    <button :style="buttonStyle" @click="$emit('zoomIn')">+</button>
    <button :style="buttonStyle" @click="$emit('zoomOut')">-</button>
  </div>
</template>

<script>
export default {
  props: {
    fill: String,
    stroke: String
  },
  computed: {
    buttonStyle() {
      return {
        backgroundColor: this.stroke,
        color: this.fill
      };
    }
  }
};
</script>

<style scoped>
.mdb-vector-map__toolbar {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
}

.mdb-vector-map__toolbar button {
  margin: 10px;
  border: none;
  width: 30px !important;
  height: 30px !important;
  border-radius: 30px;
  font-size: 18px;
  outline: none;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  font-weight: bold;
  cursor: pointer;
  transition: box-shadow 0.3s linear;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mdb-vector-map__toolbar button:hover {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 10px 0 rgba(0, 0, 0, 0.2);
}

.mdb-vector-map__toolbar button:focus {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 10px 0 rgba(0, 0, 0, 0.2);
}
</style>
